import { render, staticRenderFns } from "./dr-button-spilka-ui-kit.vue?vue&type=template&id=3f96c005&"
import script from "./dr-button-spilka-ui-kit.vue?vue&type=script&lang=js&"
export * from "./dr-button-spilka-ui-kit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports